export default __webpack_public_path__ + "assets/images/aistudio/views/a95857c99b634a080d401562cff3baf7.png";